import api from './api';

const partnerService = {
  // Get all partners with optional filters
  getAllPartners: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.country) params.append('country', filters.country);
    if (filters.activeOnly) params.append('activeOnly', filters.activeOnly);
    if (filters.limit) params.append('limit', filters.limit);

    return api.get(`/partners${params.toString() ? '?' + params.toString() : ''}`);
  },

  // Get a single partner by ID
  getPartnerById: (id) => {
    return api.get(`/partners/${id}`);
  },

  // Create a new partner
  createPartner: (partnerData) => {
    return api.post('/partners', partnerData);
  },

  // Update a partner (PUT - full update)
  updatePartner: (id, partnerData) => {
    return api.put(`/partners/${id}`, partnerData);
  },

  // Patch a partner (PATCH - partial update)
  patchPartner: (id, partnerData) => {
    return api.patch(`/partners/${id}`, partnerData);
  },

  // Delete a partner
  deletePartner: (id) => {
    return api.delete(`/partners/${id}`);
  },

  // Get only the partners the current user has permissions on
  getMyPartners: () => api.get('/partners?mine=1'),

  // Stripe Connect onboarding
  getStripeConnect: (id) => api.get(`/partners/${id}/stripe-connect`),
  createStripeConnect: (id, data) => api.post(`/partners/${id}/stripe-connect`, data),

  // Partner users
  getPartnerUsers: (id) => api.get(`/partners/${id}/users`),
  invitePartnerUser: (id, data) => api.post(`/partners/${id}/users`, data),
  updatePartnerUser: (id, userId, data) => api.patch(`/partners/${id}/users/${userId}`, data),
  removePartnerUser: (id, userId) => api.delete(`/partners/${id}/users/${userId}`),
};

export default partnerService;
